import { supabase } from './supabaseClient';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const PUBLIC_STORAGE_BASE = SUPABASE_URL
  ? `${SUPABASE_URL}/storage/v1/object/public/problem-images`
  : '';

const base64ToBlob = (base64: string): Blob => {
  const [metadata, data] = base64.split(',');
  const mimeMatch = metadata.match(/data:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
};

const generateFilePath = (userId: string, context: string) => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).slice(2, 8);
  return `${userId}/quant/${context}-${timestamp}-${random}.jpg`;
};

const isRemoteUrl = (path?: string | null) =>
  !!path && path.startsWith('http');

const buildPublicUrl = (path: string) => {
  if (!PUBLIC_STORAGE_BASE) return path;
  return `${PUBLIC_STORAGE_BASE}/${path}`;
};

const uploadProblemImage = async (
  base64: string,
  userId: string,
  context: string
): Promise<{ path?: string; publicUrl?: string; error?: string }> => {
  if (!base64 || isRemoteUrl(base64)) {
    return { path: base64, publicUrl: base64 };
  }

  const blob = base64ToBlob(base64);
  const filePath = generateFilePath(userId, context);

  const { error } = await supabase.storage
    .from('problem-images')
    .upload(filePath, blob, {
      contentType: blob.type || 'image/jpeg',
      upsert: false
    });

  if (error) {
    console.error('Supabase storage upload error:', error.message);
    return { error: error.message };
  }

  return {
    path: filePath,
    publicUrl: buildPublicUrl(filePath)
  };
};

const getPublicUrl = (path?: string | null): string | undefined => {
  if (!path) return undefined;
  if (!path || path.startsWith('data:') || isRemoteUrl(path)) return path || undefined;
  return buildPublicUrl(path);
};

export const storageService = {
  uploadProblemImage,
  getPublicUrl
};

